import { render, staticRenderFns } from "./ZjzqrEdit.vue?vue&type=template&id=ef8cf07e&scoped=true"
import script from "./ZjzqrEdit.vue?vue&type=script&lang=js"
export * from "./ZjzqrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8cf07e",
  null
  
)

export default component.exports